module.exports = __webpack_public_path__ + "static/media/slide9.8aa5762b.gif";